module.exports = __webpack_public_path__ + "img/module-thumb.e53a4aba.jpg";